import React from "react";
import { motion } from "framer-motion";
import DOMPurify from "dompurify";
import { PaywallGate, SupportStrip } from "./Paywall";
import FeedbackDropZone from "./FeedbackDropZone";

// Chapter IDs where a feedback drop-zone appears.
const FEEDBACK_HOOKS = {
  "code-languages": {
    section: "free",
    title: "End of the free preview — tell AMC what you think",
    subtitle: "You've made it through the free four chapters. Before you decide to unlock the rest, drop a quick note. Loved it? Confused? Tell AMC on a post-it.",
  },
  glossary: {
    section: "paid",
    title: "You finished the book — one last favour",
    subtitle: "What worked? What should the Complete Edition dig deeper into? Scribble it below and drop it in the box.",
  },
};

export default function ChapterPage({ chapter, pageIndex, totalPages, locked = false }) {
  if (locked) return <PaywallGate chapter={chapter} />;
  const feedback = FEEDBACK_HOOKS[chapter.id];
  return (
    <motion.article
      key={chapter.id}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="book-page max-w-3xl mx-auto px-6 sm:px-12 py-10 sm:py-14"
      data-testid={`chapter-page-${chapter.id}`}
    >
      <div className="flex items-baseline justify-between mb-2 text-slate-500">
        <span className="font-mono text-xs tracking-widest uppercase text-cyan-400/80">
          {chapter.number}
        </span>
        <span className="font-mono text-xs">
          Page {pageIndex + 1} of {totalPages}
        </span>
      </div>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-3">
        {chapter.title}
      </h1>
      <p className="font-body italic text-slate-400 mb-8 border-l-2 border-cyan-400/40 pl-4">
        {chapter.summary}
      </p>
      <div
        className="prose-book font-body text-slate-200 text-base sm:text-[17px] leading-relaxed sm:leading-[1.75]"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(chapter.content) }}
      />
      {feedback && (
        <FeedbackDropZone
          section={feedback.section}
          title={feedback.title}
          subtitle={feedback.subtitle}
        />
      )}
      <div className="mt-14 pt-6 border-t border-cyan-400/15 flex items-center justify-between text-xs uppercase tracking-widest text-slate-500 font-heading">
        <span>AMC inNOVAtions</span>
        <span>ABC&apos;S of AI</span>
      </div>
      <SupportStrip />
    </motion.article>
  );
}
